/**
 * Shared mapping from a generation-job/item status string to a Badge tone.
 *
 * Extracted from HomePage / GenerationJobsPage / GenerationJobDetailPage, which each carried an
 * identical (or near-identical) inline `statusTone` — one source of truth keeps the colour
 * semantics consistent across every place a job status is shown.
 */
export type BadgeTone =
  | "default"
  | "primary"
  | "success"
  | "warning"
  | "danger"
  | "accent";

export function statusTone(status: string): BadgeTone {
  switch (status) {
    case "completed":
      return "success";
    case "failed":
      return "danger";
    case "partial":
      return "warning";
    case "running":
    case "pending":
      return "primary";
    default:
      return "default";
  }
}
